import { RouteObject } from "react-router"
import ProcedimentoList from "./view/procedimento.list"
import { rotas,menuRotas } from "../../services/router"
import { MainMenu } from "../../config/data.types"
import { MenuOpen } from "@mui/icons-material"

export enum PathRotaProcedimento {
    procedimento = "/procedimento"
}

const routerProcedimento: RouteObject = {
    path: PathRotaProcedimento.procedimento,
    element: <ProcedimentoList/>,
}


export const navigationToProcedimentoView = ()=> rotas.navigate(PathRotaProcedimento.procedimento)

export function startRouterProcedimento(){
    const menu:MainMenu = {
        text:"Procedimentos",
        icon:<MenuOpen />,
        eventOnClick:navigationToProcedimentoView
    }
    menuRotas.push(menu);
    return routerProcedimento
}